"use client"

import { useEffect, useState } from "react";

export default function GlobalTooltip() {
    const [content, setContent] = useState<string | null>(null);
    const [pos, setPos] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleOver = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const title = target?.getAttribute?.("title");

            if (title) {
                setContent(title);
                target.removeAttribute("title"); // prevent native tooltip
                target.setAttribute("data-title", title);
            }
        };

        const handleMove = (e: MouseEvent) => {
            setPos({ x: e.pageX + 12, y: e.pageY + 12 });
        };

        const handleOut = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const dataTitle = target?.getAttribute?.("data-title");
            if (dataTitle) {
                target.setAttribute("title", dataTitle);
                target.removeAttribute("data-title");
            }
            setContent(null);
        };

        document.addEventListener("mouseover", handleOver);
        document.addEventListener("mousemove", handleMove);
        document.addEventListener("mouseout", handleOut);

        return () => {
            document.removeEventListener("mouseover", handleOver);
            document.removeEventListener("mousemove", handleMove);
            document.removeEventListener("mouseout", handleOut);
        };
    }, []);

    if (!content) return null;

    return (
        <div
            style={{
                position: "absolute",
                top: pos.y,
                left: pos.x,
                padding: "6px 8px",
                background: "#111",
                color: "#fff",
                borderRadius: 6,
                fontSize: 12,
                pointerEvents: "none",
                zIndex: 9999,
            }}
        >
            {content}
        </div>
    );
}